import moment from 'moment'
import emptyImage from '@/static/imgs/message-empty.png'
export enum StatusEnum {
  /** 待处理 */
  PENDING = 0,
  /** 处理中 */
  PROCESSING = 1,
  /** 处理失败 */
  ALL_FAILURE = 2,
  /** 部分失败 */
  PARTIAL_FAILURE = 3,
  /** 成功 */
  SUCCESS = 4,
}
import { LANGUAGE } from '@/constants'

export function taskIsPending(taskStatus: number) {
  return [StatusEnum.PENDING, StatusEnum.PROCESSING].includes(taskStatus)
}

export function taskIsFail(taskStatus: number) {
  return [StatusEnum.ALL_FAILURE, StatusEnum.PARTIAL_FAILURE].includes(taskStatus)
}

export function taskIsSuccess(taskStatus: number) {
  return [StatusEnum.SUCCESS].includes(taskStatus)
}

export const convertData = (list, i18n) => {
  const selfLanguageInfo = LANGUAGE.filter((item) => item.lang === i18n.language)
  const lang = selfLanguageInfo[0] ? selfLanguageInfo[0].languageType : 'en'
  const noticeItems = []
  list.forEach((item) => {
    const noticeItem = { title: '', content: '', image: '', date: '', isNew: false }
    const dateTime = moment(item?.notifyDetail?.onlineTime).format('YYYY-MM-DD')
    const localeTitle = item?.notifyDetail?.localeTitle
    const localeContent = item?.notifyDetail?.localeContent
    const localePicture = item?.notifyDetail?.localePicture

    const title = localeTitle?.find((it) => {
      return it.key === lang
    })
    //默认语言标题
    const defaultTitle = localeTitle?.find((it) => {
      return it.defaultLanguage
    })

    //默认语言内容
    const content = localeContent?.find((it) => {
      return it.key === lang
    })
    const defaultContent = localeContent?.find((it) => {
      return it.defaultLanguage
    })
    const picture = localePicture?.find((it) => {
      return it.key === lang
    })
    //默认语言图片
    const defaultPicture = localePicture?.find((it) => {
      return it.defaultLanguage
    })

    noticeItem.title = title?.value || defaultTitle?.value || ''
    noticeItem.content = content?.value || defaultContent?.value || ''
    noticeItem.image = picture?.pc || defaultPicture?.pc || emptyImage
    noticeItem.date = dateTime
    noticeItem.isNew = !item.read
    // noticeItem.isNew = true
    noticeItems.push(noticeItem)
  })
  return noticeItems
}
